(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/assets/javascripts/racing-router.js') >= 0) return;  svs.modules.push('/modules/racing-game/assets/javascripts/racing-router.js');

'use strict';

const {
  useEffect
} = React;
const {
  PlayerRouter,
  Route
} = svs.app.ReactRouter;
const {
  PlayerServiceProvider
} = svs.components.racing.player_service_state;
const {
  PlayProvider
} = svs.racing_game.components.playContext;
const {
  RaceServiceProvider
} = svs.components.racing.race_service_state;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  rootErrorContext: RootErrorContext
} = svs.racing_game;
const {
  ErrorFallback
} = svs.racing.errorFallback;
const {
  useStaticTabs
} = svs.racing_game.components.hooks;
const {
  ContentView,
  GameView,
  routes
} = svs.racing_game;
const {
  VODProvider
} = svs.racing;
const racingRoutes = Object.keys(routes).reduce((allRoutes, route) => [...allRoutes, ...routes[route]], []);
const isMobile = svs.core.detect.formfactor.mobile();
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const RacingRouter = () => {
  const staticTabs = useStaticTabs();
  useEffect(() => {
    if (isSelfService) {
      const selfserviceNavBtn = document.querySelector('.selfservice-nav-btn');
      const prevInnerHTML = selfserviceNavBtn.innerHTML;
      const startPageLink = svs.core.urlMapping.get('racingArena');
      selfserviceNavBtn.innerHTML = "<a href=".concat(startPageLink, " class=\"btn btn-100 btn-transparent-default\" title=\"Till H\xE4star start\"><span class=\"btn-link-text\">H\xE4star start</span></a>");
      return () => {
        selfserviceNavBtn.innerHTML = prevInnerHTML;
      };
    }
  }, []);
  return React.createElement(VODProvider, null, React.createElement(PlayerRouter, {
    basename: svs.core.data.baseUrl
  }, React.createElement(PlayerServiceProvider, null, React.createElement(RaceServiceProvider, null, React.createElement(ErrorBoundary, {
    context: RootErrorContext,
    fallback: ErrorFallback,
    reloadOnRetry: true
  }, React.createElement(Route, {
    exact: true,
    path: racingRoutes
  }, React.createElement(PlayProvider, null, isMobile ? React.createElement("div", {
    className: "game-holder"
  }, React.createElement(GameView, {
    staticTabs: staticTabs
  })) : React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xl-7 col-lg-7 col-md-6 col-sm-6"
  }, React.createElement("div", {
    className: "left-column",
    id: "left-column"
  }, React.createElement("div", {
    id: "game"
  }, React.createElement(GameView, {
    staticTabs: staticTabs
  })))), React.createElement("div", {
    className: "col-xl-5 col-lg-5 col-md-6 col-sm-6"
  }, React.createElement("div", {
    className: "right-column",
    id: "right-column"
  }, React.createElement("div", {
    id: "content"
  }, React.createElement(Route, {
    exact: true,
    path: racingRoutes
  }, React.createElement(ContentView, {
    staticTabs: staticTabs
  })))))))))))));
};
svs.racing_game.RacingRouter = RacingRouter;

 })(window);